import ArieteIcon from '@/components/shared/icons/recommendation-icons/ariete-icon';
import BufonIcon from '@/components/shared/icons/recommendation-icons/bufon-icon';
import CapitanArieteIcon from '@/components/shared/icons/recommendation-icons/capitan-ariete-icon';
import ChollosIcon from '@/components/shared/icons/recommendation-icons/chollos-icon';
import RevulsivoIcon from '@/components/shared/icons/recommendation-icons/revulsivo-icon';
import ImageBox from '@/components/shared/player-box';
import CustomModal from '@/DesignSystem/components/custom-modal/CustomModal';
import { getMasterPhotoById } from '@/helpers/images-helper';
import { Box, Typography } from '@mui/material';

const DonquiTipsJugadores = ({ players }) => {
    const getInfoIcon = (text) => {
        switch (text) {
            case 'Revulsivo':
                return <RevulsivoIcon />;
            case 'Ariete':
                return <ArieteIcon />;
            case 'Bufón':
                return <BufonIcon />;
            case 'Capitán':
                return <CapitanArieteIcon />;
            case 'Chollo':
                return <ChollosIcon />;
            default:
                return null;
        }
    };

    const renderPlayers = () => {
        const sections = [
            { title: 'Capitán', filterKey: 'isCapitan' },
            { title: 'Ariete', filterKey: 'isAriete' },
            { title: 'Chollo', filterKey: 'isChollo' },
            { title: 'Revulsivo', filterKey: 'isRevulsivo' },
            { title: 'Bufón', filterKey: 'isBufon' },
        ];

        if (players?.length > 0) {
            const allPlayers = sections.flatMap((section) => {
                return players
                    .filter((player) => player[section.filterKey])
                    .map((player) => ({ ...player, category: section.title }));
            });

            return (
                <Box display="flex" flexWrap="wrap">
                    {allPlayers.map((player, index) => (
                        <Box
                            key={index}
                            style={{
                                width: '33%',
                                textAlign: 'center',
                                padding: '8px',
                            }}
                        >
                            <Box display="flex" alignItems="center" justifyContent="center" mt={1}>
                                {getInfoIcon(player.category)}
                                <Typography variant="caption" style={{ marginLeft: '4px', fontSize: '10px' }}>
                                    {player.category}
                                </Typography>
                            </Box>
                            <ImageBox
                                image={getMasterPhotoById(player?.id)}
                                width={80}
                                height={80}
                                styles={{ marginBottom: '4px' }}
                            />
                            <Box bgcolor={'background.darkCard'}>
                                <Typography fontSize={14}>{player?.name}</Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            );
        }
    };

    return renderPlayers();
};

const DonquiTipsModal = ({ open, onClose, players }) => {
    return (
        <CustomModal open={open} onClose={onClose} title={'DonquiPicks'}>
            <DonquiTipsJugadores players={players} handleClose={onClose} />
        </CustomModal>
    );
};

export default DonquiTipsModal;
